export const getProfileImageUrl = (photoPath, secondaryPathOrGender, genderOrFallback) => {
  if (photoPath && typeof photoPath === 'string' && photoPath.trim() !== '') {
    if (photoPath.startsWith('http://') || photoPath.startsWith('https://') || photoPath.startsWith('data:')) {
      return photoPath;
    }
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const serverUrl = apiBase.replace(/\/api\/?$/, '');
    const cleanPath = photoPath.startsWith('/') ? photoPath : `/${photoPath}`;
    return `${serverUrl}${cleanPath}`;
  }

  const secondaryPath = typeof secondaryPathOrGender === 'string' && (secondaryPathOrGender.startsWith('http') || secondaryPathOrGender.startsWith('/')) ? secondaryPathOrGender : null;
  if (secondaryPath && secondaryPath.trim() !== '') {
    if (secondaryPath.startsWith('http://') || secondaryPath.startsWith('https://') || secondaryPath.startsWith('data:')) {
      return secondaryPath;
    }
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const serverUrl = apiBase.replace(/\/api\/?$/, '');
    const cleanPath = secondaryPath.startsWith('/') ? secondaryPath : `/${secondaryPath}`;
    return `${serverUrl}${cleanPath}`;
  }

  return '/assets/images/avatar_person.png';
};
